import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { faRotate, faArrowLeft, faDownload } from '@fortawesome/free-solid-svg-icons';
import { StockService } from 'src/app/share/services/stock/stock.service';


@Component({
    selector: 'app-orders-export-list',
    templateUrl: './orders-export-list.component.html',
    styleUrls: ['./orders-export-list.component.scss'],
    standalone: false
})
export class OrdersExportListComponent implements OnInit {

  protected readonly faRotate = faRotate;
  protected readonly faArrowLeft = faArrowLeft;
  protected readonly faDownload = faDownload;

  @Output() backToSale: EventEmitter<any> = new EventEmitter();

  data: any[] = [];
  loader: boolean = false;
  page: number = 0;
  errorMessage: string = '';

  constructor(
    private readonly stockService: StockService,
  ) {}


  ngOnInit(): void {
    this.getExportList();
  }


  getExportList() {
    this.loader = true;
    this.stockService.getSalesExportList({page: this.page}).subscribe({
      next:(res: any)=> {
        this.loader = false;
         let data = res.data || [];
        this.data = [...this.data, ...data]
      },
      error:(error: any)=> {
        this.loader = false;
        this.errorMessage = error.error.message || "something went wrong to get list"
      }
    })
  }

  refreshList() {
    this.data = [];
    this.page = 0;
    this.getExportList();
  }

  onScroll() {
    this.page++;
    this.getExportList();
  }


  downloadSheet(item: any) {
    if (!item.sheetUrl) return;
    const anchor = document.createElement('a');
    anchor.href = item.sheetUrl;
    anchor.download = item.filePath;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  }

  goBack() {
    this.backToSale.emit()
  }

  closeToster() {
    this.errorMessage = ''
  }

}
